import { Component } from '@angular/core';
import { ModalController, Platform, NavParams, ViewController } from 'ionic-angular';
import { datos } from '../../providers/datos';
import { NavController} from 'ionic-angular';
import { Modal } from '../modal/modal';

import { ActionSheetController } from 'ionic-angular';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

import { Facebook, FacebookLoginResponse } from '@ionic-native/facebook';

import { NativeStorage } from '@ionic-native/native-storage';
declare var cordova:any;
declare var document:any;
declare var window:any;
declare var jQuery:any;
declare var $:any;
declare var swal:any;


@Component({
  selector: 'login',
  templateUrl: 'login.html',
})
export class Login {
  menu ='login';
  background='assets/images/fondo2.png';
  public usernameLogin: string;
  public passwordLogin: string;
  private isUsernameValidLogin: boolean = true;
  private isPasswordValidLogin: boolean = true;

  public usernameRegister: string;
  public passwordRegister: string;
  public countryRegister: string;
  public cityRegister: string;
  public emailRegister: string;

  private isEmailValidRegister: boolean = true;
  private isUsernameValidRegister: boolean = true;
  private isPasswordValidRegister: boolean = true;
  private isCityValidRegister: boolean = true;
  private isCountryValidRegister: boolean = true;

  private regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public selectedItem = "login";

total=0;
parametros=
{
	"id":0,
  "nombres":"",
  "apellidos":"",
  "email":"",
  "clave":""
};

data = {
  "nombre": "Nombre",
  "apellidos":"Apellidos",

  "segmentLogin":       "Login",
  "segmentRegister":    "Registro",
  
  "toolbarTitle"        : "Register + logo",
  "logo"                : "assets/images/logo/2.png",

  "title"               : "Register your new account",
  "background"          : "assets/images/background/.jpg",
  "username"            : "Enter your username",
  "city"                : "Your home town",
  "country"             : "Where are you from?",
  "password"            : "Enter your password",
  "email"               : "Your e-mail address",
  "skip"                : "Skip",
  "birth"               : "Date",
  "lableUsername"       : "USERNAME",
  "lablePassword"       : "PASSWORD",
  "lableEmail"          : "E-MAIL",
  "lableCountry"        : "COUNTRY",
  "lableCity"           : "CITY",
  "lableDate"           : "BIRTH DATE",
  "dateFormat"          : "MM/DD/YYYY",
  "errorUser"           : "Field can't be empty",
  "errorPassword"       : "Field can't be empty",
  "errorEmail"          : "Invalid email address",
  "errorCountry"        : "Field can't be empty",
  "errorCity"           : "Field can't be empty",
  "errorBirth"          : "Field can't be empty",
  "items": [
      {
          "id": 1,
          "title": "I agree with terms & conditions",
          "isChecked": true
      },
      {
          "id": 2,
          "title": "Keep me log in",
          "isChecked": false
      }
    ],
    "login": 
      {   "title": "Iniciar sesión",
          "login": "Iniciar",
          "username": "username",
          "labelUsername":"Usuario",
          "password": "contraseña",
          "labelPassword": "Contraseña",          
          "facebookLogin":"facebook",
          "errorPassword": "errorPassword"
     
      },
    "register": 
      {
        "title": "Registro de usuario",
        "register": "Registrarse",
        "username": "E-mail",
        "labelUsername":"Usuario",
        "password": "contraseña",
        "labelPassword": "Contraseña",          
        "facebookLogin":"facebook",
        "city": "ciudad",
        "telefono":"telefono",
        "nombre": "Nombre",
        "apellidos":"Apellidos"
          
      }
};

  constructor(   
   public viewCtrl: ViewController,
   public params: NavParams,
   private datos:datos,
   public navCtrl: NavController,
    public modalCtrl: ModalController,
    public actionSheetCtrl: ActionSheetController,
    private fb: Facebook,
    private nativeStorage: NativeStorage

   ) {

    // this.producto= this.params.get('producto');

    // console.log( this.producto);

  }

  ionViewDidLoad() {
    this.sacarTotal();

  }



  add(i){
    console.log(i);
    this.datos.pedido.items[i].cantidad ++;
    this.RecalcularPrecio(i);

  }

  isEnabled(a){
    return true;
  }


  login2(){


this.parametros.email= this.parametros.email.replace(" ", "");
this.parametros.clave= this.parametros.clave.replace(" ", "");


if(!this.parametros.clave || !this.parametros.email  ){

  this.datos.Toast("TODOS LOS DATOS SON OBLIGATORIOS !",1000);

  return 
}



    // this.datos.login.nombre ="CRYSTIAN";
    // this.datos.login.apellido1 ="BRAVO";
    this.datos.login.login =1;
    // this.datos.login.puntos ="34";
    // this.viewCtrl.dismiss({dato:0});
this.cancel();
      


 }

 getLoginEspecialistas(){


this.parametros.email= this.parametros.email.replace(" ", "");
this.parametros.clave= this.parametros.clave.replace(" ", "");


if(!this.parametros.clave || !this.parametros.email  ){

  this.datos.Toast("TODOS LOS DATOS SON OBLIGATORIOS !",1000);

  return 
}

this.datos.loader(1);


  this.datos.getLoginEspecialistas(1).
  subscribe((data) => {
    this.datos.loader(0);

      if (data.data.length) {
        this.datos.Toast("CORRECT0 !",2000);
        this.datos.login=data.data[0];

        console.log("guardado");
        this.datos.setLocalStorage('login_espe',JSON.stringify(this.datos.login));

        setTimeout(() => {
          // this.menu="registro";
          this.cancel()
            
          }, 2000);


        
      }

      else {
        this.datos.Toast("ERROR LOGIN !",2000);

      }


    },

    (error: any) => {
this.datos.loader(0);

        console.log(error);
    });
    


}
 

  loginFacebook(){

  }

  modal(item?) {
   
  
  }



  
  rm(i){
   

  }


RecalcularPrecio(i){
  
  
}


del(item){
  


}

sacarTotal(){

}
  dismiss(){
    this.viewCtrl.dismiss();

  }

cancel(){
  
    this.viewCtrl.dismiss({dato:0});

}


selectPago() {
  
}


calificar(){
  

}

}


// WEBPACK FOOTER //
// ./src/pages/login/login.ts